export const LISTS = [
  {
    id: 1,
    name: "General List A",
    packId: "general",
    categories: [
      "Boys' names",
      "U.S. cities",
      "Things that are cold",
      "School subjects",
      "Web sites",
      "Animals",
      "Things in a kitchen",
      "Flowers / Plants",
      "Things that are black",
      "Cartoon characters",
      "Types of drink",
      "Occupations"
    ]
  },
  {
    id: 2,
    name: "General List B",
    packId: "general",
    categories: [
      "Girls' names",
      "Countries",
      "Things that are hot",
      "Colors",
      "Apps / Software",
      "Insects / Bugs",
      "Things in a bedroom",
      "Trees / Shrubs",
      "Things that are white",
      "Superheroes / Villains",
      "Types of food",
      "Hobbies"
    ]
  },
  {
    id: 3,
    name: "Recreation & Hobbies",
    packId: "recreation",
    categories: [
      "Musical instruments",
      "Car parts",
      "Things you wear",
      "Terms of endearment",
      "Things in a garage",
      "Ocean creatures",
      "Sports",
      "Song titles",
      "Pizza toppings",
      "Things that are round",
      "Historical figures",
      "Tools"
    ]
  },
  {
    id: 4,
    name: "Kid & Family Friendly",
    packId: "family",
    categories: [
      "Toys / Games",
      "Fruits / Vegetables",
      "School supplies",
      "Disney characters",
      "Things that make noise",
      "Things that are sticky",
      "Pet names",
      "Birthday party items",
      "Zoo animals",
      "Ice cream flavors",
      "Things in the sky",
      "Clothing items"
    ]
  },
  {
    id: 5,
    name: "Travel & Geography",
    packId: "travel",
    categories: [
      "States / Provinces",
      "Tourist attractions",
      "Things you pack in a suitcase",
      "Modes of transportation",
      "Languages",
      "Rivers / Lakes / Oceans",
      "Airport codes / Airlines",
      "Street names",
      "Words in another language",
      "Items found in a hotel room",
      "Things with wheels",
      "Souvenirs"
    ]
  },
  {
    id: 6,
    name: "Pop Culture & Entertainment",
    packId: "entertainment",
    categories: [
      "Movies",
      "Actors / Actresses",
      "Board games",
      "Video games",
      "Musicians / Bands",
      "TV shows",
      "Book titles",
      "Brands / Logos",
      "Fictional places",
      "Famous catchphrases",
      "YouTubers / Influencers",
      "Things in a movie theater"
    ]
  },
  {
    id: 7,
    name: "Food & Drink",
    packId: "food",
    categories: [
      "Breakfast foods",
      "Vegetables",
      "Fruits",
      "Spices / Herbs",
      "Desserts / Sweets",
      "Beverages / Drinks",
      "Restaurant chains",
      "Things you eat with a spoon",
      "Dairy products",
      "Fast food items",
      "Types of candy",
      "Things you bake"
    ]
  },
  {
    id: 8,
    name: "Home & Everyday Life",
    packId: "home",
    categories: [
      "Furniture",
      "Cleaning supplies",
      "Things in a bathroom",
      "Things in a living room",
      "Items in a toolbox",
      "Gardening tools",
      "Clothing brands",
      "Footwear types",
      "Things in a junk drawer",
      "Office supplies",
      "Items on a nightstand",
      "Things made of wood"
    ]
  },
  {
    id: 9,
    name: "Science & Nature",
    packId: "science",
    categories: [
      "Elements / Chemicals",
      "Weather terms",
      "Body parts",
      "Gemstones / Minerals",
      "Constellations / Space terms",
      "Birds",
      "Reptiles / Amphibians",
      "Flowers",
      "Green things",
      "Dynamic verbs (action words)",
      "Adjectives (descriptive words)",
      "Natural disasters"
    ]
  },
  {
    id: 10,
    name: "Sports & Fitness",
    packId: "recreation",
    categories: [
      "Sports teams",
      "Famous athletes",
      "Sports equipment",
      "Outdoor activities",
      "Olympic events",
      "Games played at a park",
      "Exercise terms",
      "Hobbies / Crafts",
      "Tabletop games",
      "Card games",
      "Water sports",
      "Winter sports"
    ]
  }
]

export const PACKS = [
  { id: "general", name: "General Packs", blurb: "Standard classic categories" },
  { id: "recreation", name: "Recreation & Sports", blurb: "Sports, hobbies, and activities" },
  { id: "family", name: "Family & Kids", blurb: "Kid-friendly themes and toys" },
  { id: "travel", name: "Travel & Geography", blurb: "Places, transportation, and suitcase packing" },
  { id: "entertainment", name: "Pop Culture", blurb: "Movies, games, celebs, and music" },
  { id: "food", name: "Food & Beverage", blurb: "Dishes, snacks, kitchen, and restaurants" },
  { id: "home", name: "Around the House", blurb: "Furniture, household tasks, and yard items" },
  { id: "science", name: "Science & Nature", blurb: "Animals, body parts, weather, and dynamic verbs" }
]

export function getLists(packIds) {
  if (!packIds || !packIds.length) return LISTS
  return LISTS.filter((l) => packIds.includes(l.packId))
}
